(function () {
  if (window.__oasShipInfoInited) return;
  window.__oasShipInfoInited = true;

  function getETDate() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  function addBusinessDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  function initDateRange(el) {
    var minDays = parseInt(el.dataset.deliveryMin, 10) || 3;
    var maxDays = parseInt(el.dataset.deliveryMax, 10) || 7;
    var now = getETDate();
    var from = addBusinessDays(now, minDays);
    var to = addBusinessDays(now, maxDays);
    el.textContent = formatDate(from) + ' - ' + formatDate(to);
  }

  function isMobile() {
    return window.innerWidth < 1000;
  }

  function getHeaderHeight() {
    var selectors = [
      'header',
      '.header',
      '#header',
      '[class*="header"]',
      'nav',
      '.navbar',
      '.site-header',
      '.shopify-section-header'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0) return rect.bottom;
      }
    }
    return 0;
  }

  function initDrawer(root) {
    var panel = root.querySelector('[data-shipping-drawer-panel]');
    var overlay = root.querySelector('[data-drawer-overlay]');
    if (!panel || !overlay) return;

    var drawerBody = panel.querySelector('[data-drawer-body]');
    var fetched = false;

    function openDrawer(url) {
      var headerH = getHeaderHeight();
      panel.style.top = headerH + 'px';
      panel.style.height = 'calc(100% - ' + headerH + 'px)';
      overlay.style.top = headerH + 'px';
      panel.classList.add('is-open');
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';

      if (!fetched && url) {
        fetched = true;
        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var main =
              doc.querySelector('.shopify-section .rte') ||
              doc.querySelector('.rte') ||
              doc.querySelector('main .page__content') ||
              doc.querySelector('main article') ||
              doc.querySelector('main');
            if (drawerBody) {
              drawerBody.innerHTML = main ? main.innerHTML : html;
            }
          })
          .catch(function () {
            if (drawerBody) {
              drawerBody.innerHTML = '<p>Failed to load. <a href="' + url + '">View page →</a></p>';
            }
          });
      }
    }

    function closeDrawer() {
      panel.classList.remove('is-open');
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-shipping-policy-trigger]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!isMobile()) return;
        e.preventDefault();
        openDrawer(link.getAttribute('data-shipping-policy-url') || link.href);
      });
    });

    root.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    if (!window.__oasShipInfoEscBound) {
      window.__oasShipInfoEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.oas-shipinfo-drawer__panel.is-open').forEach(function (p) {
          var root = p.closest('[data-oas-shipinfo]');
          var o = root && root.querySelector('[data-drawer-overlay]');
          if (o) o.style.display = 'none';
          p.classList.remove('is-open');
        });
        document.body.style.overflow = '';
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-oas-shipinfo]').forEach(function (root) {
      if (root._oasShipInfoReady) return;
      root._oasShipInfoReady = true;

      root.querySelectorAll('.oas-shipinfo__date-range').forEach(initDateRange);
      initDrawer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
